module.exports = __webpack_public_path__ + "img/ic_upload.508c3345.svg";